module.exports = __webpack_public_path__ + "0416a0708c0585700570028ed36dd7c2.jpg";